<script>
import {Vue} from "ui.vue";
import {InitForm} from "../classes/init.js";

import 'citrus.vue.vue-form.fields';
import 'citrus.vue.vue-form.message';
import "citrus.vue.dialog";

export default {
	name: 'CitrusIblockElement',
	data: () => {
		return {
			metricGoal: false,
			loading: false,
			error: false,
			message: '',
			message_descr: '',
			hasResult: false,
			title: "",
			button_title: "",
			agreement_text: "",
			agreementChecked: true,
		};
	},
	created() {
	},
	methods: {
		async isValidate(component, isValid = true) {
			let val = null, self = this;
			if (component) {
				self = component;
			}

			try {
				if (!self.$refs) {
					return false;
				}

				if (self.$refs.hasOwnProperty('group')) {
					for (let group of self.$refs.group) {
						let isValidGroup = await this.isValidate(group);
						if (!isValidGroup)
							isValid = false;
					}
				}
				if (self.$refs.hasOwnProperty('field')) {
					for (let field of self.$refs.field) {
						val = await field.checkValid();
						if (!val) {
							isValid = false;
						}
					}
				}
			} catch (e) {
				console.warn(e);
			}

			return isValid;
		},
		saveForm: async function (event) {
			event.preventDefault();
			if (this.loading) {
				return;
			}

			let isValid = await this.isValidate();
			if (!isValid) {
				return;
			}

			this.loading = true;
			this.hasResult = false;

			InitForm.sendRequest(this.arFields, 'saveForm', {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}, false)
				.then((message) => {

					// отправим метрику
					if(this.metricGoal)
					{
						this.$metrika.reachGoal(this.metricGoal);
						this.$gtag.event(this.metricGoal);
					}

					this.onSuccess(message)
				})
				.catch((error) => {
					this.onError(error);
				});
		},
		onSuccess(message) {
			this.loading = false;
			this.hasResult = true;

			this.error = false;
			this.message = message && message.length > 0 ? message : this.loc.TPL_CF_IBLOCK_ELEMENT_OK_MESSAGE;
			this.message_descr = this.loc.TPL_CF_IBLOCK_ELEMENT_OK_MESSAGE_DESCR;

			if (!this.$dialog) {
				alert(this.message + " " + this.message_descr);
				this.restartForm();

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					body: this.message_descr,
					pretitle: '<div class="m-auto h-28 mb-6">' + this.icons.success + '</div>'
				}, {
					html: true,
					okText: this.loc.TPL_CF_IBLOCK_ELEMENT_CLOSE
				})
				.then(() => {
					this.restartForm();
				});
		},
		onError(error) {
			this.loading = false;
			this.hasResult = true;

			this.error = true;
			this.message = error && error.length > 0 ? error : this.loc.TPL_CF_IBLOCK_ELEMENT_ERROR_MESSAGE;
			this.message_descr = this.loc.TPL_CF_IBLOCK_ELEMENT_ERROR_MESSAGE_DESC;

			if (!this.$dialog) {
				alert(this.message + " " + this.message_descr);
				this.restartForm();

				return;
			}

			this.$dialog
				.alert({
					title: this.message,
					body: this.message_descr,
				}, {
					html: true,
					okText: this.loc.TPL_CF_IBLOCK_ELEMENT_CLOSE
				})
				.then(() => {
					this.restartForm();
				});
		},
		restartForm: function () {
			this.loading = false;
			this.hasResult = false;
			this.error = false;
			this.message = "";
			this.message_descr = "";

			for (let field of this.arFields) {
				if (true === field.HIDDEN)
					continue;

				field.VALUE = '';

				if (field.GROUP_FIELD) {
					for (let groupItem of field.ITEMS) {
						groupItem.VALUE = "";
					}
				}
			}
		},
		scrollToElement: async function() {

			let slide = this.$refs['reviewTitle'];

			if (!slide) {
				return;
			}

			let top = window.scrollY + slide.getBoundingClientRect().y - 500;

			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
	},
	computed: {
		hasError() {
			return this.error && false !== this.message;
		},
		loc() {
			return Vue.getFilteredPhrases("TPL_CF_IBLOCK_ELEMENT_");
		}
	}
};
</script>